import { useEffect } from 'react'

import { KeySet } from '@eastcoal/common/types/utilities'

import { useCustomMemberGroupStoreApi } from '../hooks'
import { CustomMemberGroupStore } from '../store/interface'

import { CustomMemberGroupStoreUpdaterProps } from './interface'

const useStoreUpdater = <K extends KeySet<CustomMemberGroupStore>>(
  key: K,
  value: CustomMemberGroupStore[K]
) => {
  const { setState } = useCustomMemberGroupStoreApi()

  useEffect(() => {
    setState({ [key]: value })
  }, [setState, key, value])
}

export const CustomMemberGroupStoreUpdater = ({
  value,
  onChange,
  disabled
}: CustomMemberGroupStoreUpdaterProps) => {
  useStoreUpdater('value', value)
  useStoreUpdater('disabled', disabled)

  useStoreUpdater('onChange', onChange)

  return null
}
